














import Vue from 'vue'
import { nl2br, autoLink, adjustDateToJp } from '@/utils'

export default Vue.extend({
  name: 'InfomationItem',
  props: {
    date: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    image: {
      type: [String, Boolean],
      required: false,
      default: ''
    },
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    adjustDate(): string {
      return adjustDateToJp(this.date)
    },
    adjustLink(): string {
      return `/news/${this.id}`
    }
  },
  methods: {
    formatTitle(text: string) {
      return autoLink(nl2br(text.length > 40 ? text.substring(0, 40) + '...' : text), '_blank')
    }
  }
})
